import { IPrivateEndpointMetadata } from './private-endpoint-metadata';
import { getReadonlyControl, privateLinkResourceIdFormat, privateLinkResourceIdErrorMessage, getPrivateLinkControls } from './shared-control-metadata';


export const privateLinkServiceMetadata: IPrivateEndpointMetadata = {
    resourceType: 'Microsoft.Network/privateLinkServices',
    connectionSuffix: 'privateendpointconnections',
    resourceIdValidator: privateLinkResourceIdFormat,
    supportsFqdns: true,
    allowUpdate: true,
    groupIdMetadata: {
        '': {
            linkedServiceType: 'PrivateLinkService',
            groupId: '',
            iconClass: 'svg-i-100x100-azure_privatelinkedservice',
            displayName: stringResources.PrivateLink,
            controls: {
                creationControls: getPrivateLinkControls(),
                readonlyControls: getReadonlyControl(privateLinkResourceIdFormat, privateLinkResourceIdErrorMessage)
            }
        }
    }
};
